import { PersonsPointOfContactsService_personPointOfContactServiceGetEntities as service } from '@festina/legalentity-general-types/legalentity/hooks/PersonsPointOfContactsService_personPointOfContactServiceGetEntities'

export const useFetchPointOfContacts = service.useSuspenseQuery
